import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    Button,
    Card,
    CardContent,
    Typography,
    Grid,
    Box,
    Alert
} from "@mui/material";
import Layout from "../../layout/layout";
import CollectionsTwoToneIcon from "@mui/icons-material/CollectionsTwoTone";
import InventoryTwoToneIcon from "@mui/icons-material/InventoryTwoTone";
import SecurityIcon from "@mui/icons-material/Security";
import SettingsIcon from "@mui/icons-material/Settings";
const UtilityControl = () => {
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        const password = prompt("Enter password to access Utility Control:");
        if (password === "admin123") {
            setIsAuthenticated(true);
        } else {
            alert("Incorrect password. Access denied.");
            window.history.back();
        }
    }, []);

    const handleUtilityAction = (action) => {
        setMessage(`${action} executed successfully!`);
        setTimeout(() => setMessage(""), 3000);
    };

    if (!isAuthenticated) {
        return null;
    }

    const utilityCards = [
        {
            title: "App Banner Management",
            description: "Manage and configure app banners displayed to users",
            icon: <CollectionsTwoToneIcon sx={{ fontSize: 40 }} color="primary" />,
            action: "navigate",
            path: "/app-banners"
        },
        {
            title: "Package Management",
            description: "Review and manage subscription packages",
            icon: <InventoryTwoToneIcon sx={{ fontSize: 40 }} color="primary" />,
            action: "navigate",
            path: "/package-management"
        },
        {
            title: "App Config Manager",
            description: "Manage application configurations and settings",
            icon: <SettingsIcon sx={{ fontSize: 40 }} color="primary" />,
            action: "navigate",
            path: "/app-config-manager"
        },
        {
            title: "Security Controls",
            description: "Manage security and access controls",
            icon: <SecurityIcon sx={{ fontSize: 40 }} color="primary" />,
            action: "Security Controls"
        }
    ];

    const body = (
        <div>
            <Box sx={{ mb: 3 }}>
                <Typography variant="h5" gutterBottom>
                    Utility Control Panel
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Manage system utilities and administrative controls
                </Typography>
            </Box>

            {message && (
                <Alert severity="success" sx={{ mb: 3 }}>
                    {message}
                </Alert>
            )}

            <Grid container spacing={3}>
                {utilityCards.map((utility, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card
                            sx={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                transition: "transform 0.2s",
                                "&:hover": {
                                    transform: "translateY(-4px)",
                                    boxShadow: 3
                                }
                            }}
                        >
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                                    {utility.icon}
                                </Box>
                                <Typography variant="h6" gutterBottom align="center">
                                    {utility.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 2 }}>
                                    {utility.description}
                                </Typography>
                                <Box sx={{ display: "flex", justifyContent: "center" }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            if (utility.action === "navigate" && utility.path) {
                                                navigate(utility.path);
                                            } else {
                                                handleUtilityAction(utility.action);
                                            }
                                        }}
                                    >
                                        Open
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </div>
    );

    return <Layout title="Utility Control" body={body} />;
};

export default UtilityControl;
